<template>
	<section class="col-xs-12 block reflexiones">
		<div class="container">
			<div class="row">
				<h2 class="block__title">
				</h2>
				<div class="col-xs-12 reflexiones__slid">


					<div class="reflexiones__item" v-for="podcast in podcasts">
						<!-- <a v-bind:href="podcast.link"> -->
						<router-link :to="{ name: 'post', params: { name:podcast.slug }}">

							<figure v-if="podcast.better_featured_image !== null">
								<img v-bind:src="podcast.better_featured_image.media_details.sizes['536x412'].source_url" alt="">
							</figure>
							<figure v-else-if="podcast.featured_image_src['full'][0]">
								<img v-bind:src="podcast.featured_image_src['full'][0]" alt="">
							</figure>
							<figure v-else>
								<img v-bind:src="theme_url+'/html/assets/img/ref-slid.jpg'" alt="">
							</figure>
						<!-- </a> -->
						</router-link>
						<div class="reflexiones__title paused">
							<button class="reflexiones__player" v-bind:audio="podcast.post_meta_fields._enclosure_mp3">
								<i class="icon play-mini"></i>
							</button>
							<h3 v-html="podcast.title.rendered"></h3>
						</div>
						<div class="reflexiones__compartir compartir__player">
								<button>Compartir en <i class="icon share"></i></button>
								<ul>
									<li><a v-bind:href="'https://www.facebook.com/sharer/sharer.php?u='+podcast.link" target="_blank"><i class="fa fa-facebook"></i></a></li>
									<li><a v-bind:href="'https://twitter.com/share?url='+podcast.link+'&text='+podcast.title.rendered" target="_blank"><i class="fa fa-twitter"></i></a></li>
									<li class="itemwa"><a v-bind:href="'whatsapp://send?text='+podcast.link"><i class="fa fa-whatsapp"></i></a></li>
								</ul>
						</div>
					</div>


				</div>
			</div>
		</div>
	</section>
</template>


<script>
export default {

	props:[
		'post_id',
	],
	mounted: function() {
		const vm = this;
		vm.getPodcasts();
	},

	data() {
		return {
			base_path: rtwp.base_path,
			pageTitle: rtwp.site_name,
			theme_url:rtwp.theme_url,
			podcasts:[],
		};
	},
	methods: {
		getPodcasts: function() {
			const vm = this;
			// vm.$http.get( 'wp/v2/posts/?filter[category_slug]=podcasts&filter[meta_query][key]=enclosure')
			vm.$http.get( 'wp/v2/posts/?categories='+vm.post_id.acf.categoria)
			.then( ( res ) => {
				vm.podcasts = res.data;
				vm.loaded = 'true';
				vm.$nextTick(function(){
					activar_slick_reflexiones_portada();
					jQuery('.block__title').html(vm.post_id.title.rendered);


					setTimeout(function(){
						jQuery('div.reflexiones__title').on('click','button.reflexiones__player', function(event) {
							event.preventDefault();
							var self=this;
							var audio=jQuery('#elementodeaudio');
							var estado=jQuery(self).parent().hasClass('paused');
							if(estado!=true){
								jQuery('div.reflexiones__title').addClass('paused');
								jQuery(audio).trigger('pause');
							} else {
								jQuery(audio).prop('src',jQuery(self).attr('audio'));
								jQuery(self).parent().removeClass('paused');
								jQuery(audio).trigger('play');

							}
						});
					},500);


					init_attach();
				});

			} )
			.catch( ( res ) => {
				//console.log( `Something went wrong : ${res}` );
			} );


		}
	}
};
</script>



// WEBPACK FOOTER //
// audiosportada.vue?c6fae71c